/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { HorizontalBarChart as HorizontalBar } from '@atlassian/viz-platform-charts/charts';
import type { DataType } from '../../../common/types.tsx';
import { CustomAxisLeft } from './axis-left/index.tsx';
import { CustomLayout } from './layout/index.tsx';

type Props = {
	data: DataType[];
	width: number;
};

const MAX_WIDTH = 600;

export const HorizontalBarChart = ({ data, width: initialWidth }: Props) => {
	const width = Math.min(initialWidth, MAX_WIDTH);

	// Sort the data by value in ascending order, but keep "Other" at start
	data.sort((a: DataType, b: DataType) => {
		if (a.label === 'Other') return -1;
		if (b.label === 'Other') return 1;
		return (a.value ?? 0) - (b.value ?? 0);
	});

	return (
		<HorizontalBar<DataType>
			data={data}
			width={width}
			yAccessor={(d) => d.value}
			xAccessor={(d) => d.label}
		>
			<CustomLayout />
			<CustomAxisLeft sideBarWidth={width} />
		</HorizontalBar>
	);
};
